/* PAPETERIE MONTPARNASSE - Footer : accordeon mobile (DEV, reversible).
   Sur mobile (<=699px), replie chaque colonne du footer ; ferme par defaut, deplie au tap.
   N'agit que sur .pmf ; ne modifie pas la newsletter. Desktop : inchange.
   Reversible : retirer ce script (theme.liquid) + le bloc accordeon de pm-footer.css. */
(function () {
  var mq = window.matchMedia('(max-width:699px)');
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  function build() {
    var f = document.querySelector('.pmf');
    if (!f) { return; }
    var cols = f.querySelectorAll('.pmf__cols > .pmf__col');
    Array.prototype.forEach.call(cols, function (col) {
      if (col.__pmfAcc) { return; }
      col.__pmfAcc = true;
      var head = col.querySelector('.pmf__rowhead');
      if (!head) { return; }
      var body = document.createElement('div');
      body.className = 'pmf__body';
      var n = head.nextSibling;
      while (n) { var nx = n.nextSibling; body.appendChild(n); n = nx; }
      col.appendChild(body);
      var chev = document.createElement('span');
      chev.className = 'pmf__chev';
      chev.innerHTML = CHEV;
      head.appendChild(chev);
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-expanded', 'false');
      function toggle() {
        var o = col.classList.toggle('pmf__col--open');
        head.setAttribute('aria-expanded', o ? 'true' : 'false');
      }
      head.addEventListener('click', function () { if (mq.matches) { toggle(); } });
      head.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && mq.matches) { e.preventDefault(); toggle(); }
      });
    });
  }
  if (document.readyState !== 'loading') { build(); } else { document.addEventListener('DOMContentLoaded', build); }
})();
